import { Box, Button, Grid2, IconButton, MenuItem, Select, Snackbar, TextField, Typography } from "@mui/material";
import TokenError from "../tokenError";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import config from '../../config/config.js';
import CloseIcon from '@mui/icons-material/Close';
import {makeGetRequestToUrl} from '../commonFunc.jsx';
import {makePostRequestToUrl} from '../commonFunc.jsx';
import constants from '../../constant.js';
import mapPin from '../../assets/icons/LocationPin.svg';
import RadiusFrame from '../../assets/images/RadiusFrame.svg';
import binButton from '../../assets/images/binButton.svg';
import { Label } from "flowbite-react";
import pickupMarker from '../../assets/icons/PickupIcon.svg';
import stopMarker from '../../assets/images/stopsMarker.svg';
import selectedStopMarker from '../../assets/images/selectedStopMarker.svg';
import stopsDefaultImg from '../../assets/images/stopsDefaultImg.webp';
import axios from "axios";
import { GoogleMap, Marker } from "@react-google-maps/api";
import { useGoogleMapsLoader } from "../../utils/GoogleMapsLoader";

const LIBRARIES = ["maps", "drawing", "places", "geometry"];

const ShuttleStops = () => {

    const [shuttleStopsData, setShuttleStopsData] = useState([]);
    const [tokenExpired, setTokenExpired] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const token = localStorage.getItem('token');
    const cities = JSON.parse(localStorage.getItem('cities'));
    const [cityFilter, setCityFilter] = useState(cities[0].city_id);
    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const [city, setCity] = useState(cities[0]);
    const [imageList, setImageList] = useState([]);
    const [openAddModal, setOpenAddModal] = useState(false);
    const [openEditModal, setOpenEditModal] = useState(false);
    const navigate = useNavigate();
    const inputRef = useRef(null); 
    const [message, setMessage] = useState('');
    const [snackbar, showSnackbar] = useState(false);
    const [stopLat, setStopLat] = useState('');
    const [stopLng, setStopLng] = useState('');
    const [stopAddress, setStopAddress] = useState('');
    const [stopName, setStopName] = useState('');
    const [stopRadius, setStopRadius] = useState('');
    const [stopId, setStopId] = useState('');
    const [isDelete, setIsDelete] = useState(0);
    const [image, setImage] = useState('');
    const [selectedGridData, setSelectedGridData] = useState([]);
    const [selectedFiles, setSelectedFiles] = useState([]);// Add a default value (e.g., 'IN' for India or empty string for global search)
    const map_search_preference = localStorage.getItem('map_search_preference') || '';
    const [mapCenter, setMapCenter] = useState({
        lat: 28.644800, 
        lng: 77.216721
    });
    const mapRef = useRef(null);
    useEffect(() => {
        if (openEditModal) {
            setMapCenter({ lat: Number(stopLat), lng: Number(stopLng) });
        }
    }, [stopLat, stopLng, openEditModal]);

    // const loaderOptions = {
    //     id: 'google-map-script',
    //     googleMapsApiKey: constants.API_KEY, // Replace with your actual API key
    //     libraries: LIBRARIES,
    // }
    
    // const { isLoaded, loadError } = useJsApiLoader(loaderOptions);
    const { isLoaded, loadError } = useGoogleMapsLoader();
    const [map, setMap] = useState(null)
    const containerStyle = {
        width: '100%',
        height: '580px',
      };
    const center = {
        // lat: 28.644800, lng: 77.216721
        lat: Number(shuttleStopsData.latitude), lng: Number(shuttleStopsData.longitude)
    };
    const pickupLatLng = {
        lat: 28.644800, lng: 77.216721
    };
    
    const onLoad = React.useCallback((map) => {
        console.log('Map loaded successfully');
        setMap(map); // Store the map instance
    }, []);

    const onUnmount = React.useCallback(function callback(map) {
        setMap(null)
    }, []);

    const fetchShuttleStops = async() => {
        try {
            const url = serverUrl + '/shuttle/fetch_stops';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                setShuttleStopsData(response.data);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        } 
        catch (error) {
            console.log('error', error);
        }
    }
    useEffect(() => {
        fetchShuttleStops();
    }, [cityFilter]);

    const handleGridClick = (data) => {
        setSelectedGridData(data);
    }
    const handleOpenEdit = (row) => {
        console.log('row==', row);
        setOpenEditModal(true);
        setStopId(row.stop_id);
        setStopName(row.name);
        setStopAddress(row.address);
        setStopRadius(row.radius);
        const latitude = Number(row.latitude);
        const longitude = Number(row.longitude);
        // setImage(row.stop_image);
        const imageArray = row.stop_image.split(';;');
        setImageList(imageArray);
        setStopLat(latitude);
        setStopLng(longitude);
        // setMapCenter({ lat: latitude, lng: longitude });
    }
    useEffect(() => {
        console.log("stopLat:", stopLat, "stopLng:", stopLng);
    }, [openEditModal, stopLat, stopLng]);
    

    const handleDeleteFunc = (row) => {
        setIsDelete(1);
        setStopId(row.stop_id);
        setStopName(row.name);
        setStopAddress(row.address); 
        const imageArray = row.stop_image.split(';;');
        setImageList(imageArray);
        setStopRadius(row.radius);
        const latitude = Number(row.latitude);
        const longitude = Number(row.longitude);
        setImage(row.stop_image);
        setStopLat(latitude);
        setStopLng(longitude);
        // saveData();
    }

    useEffect(()=>{
        if(isDelete==1){
            saveData();
        }
    }, [isDelete])
    const handleOpenAddModal = () => {
        setOpenAddModal(true);
        setOpenEditModal(false);
        setStopId('');
        setStopName('');
        setStopAddress('');
        setStopRadius('');
        setStopLat('');
        setStopLng('');
        setImageList([]);
    }
    const handleClose = () => {
        setOpenAddModal(false);
        setOpenEditModal(false);
    }

    useEffect(() => {
        if (isLoaded && stopLat && stopLng && mapRef.current) {
            console.log("Manually adding marker via API");
    
            new window.google.maps.Marker({
                position: { lat: stopLat, lng: stopLng },
                map: mapRef.current,  // Ensure the marker is added to the correct map
                title: stopName,
            });
        }
    }, [isLoaded, stopLat, stopLng]);
    

    const saveData = async() => {
        const token = localStorage.getItem('token');

        if(stopName==""){
            setMessage('Please enter stop name.');
            showSnackbar(true);
            return;
        }
        else if(stopAddress==""){
            setMessage('Please enter stop address.');
            showSnackbar(true);
            return;
        }
        else if(stopRadius==""){
            setMessage('Please enter stop radius.');
            showSnackbar(true);
            return;
        }

        const imageUrls = imageList.join(";;");
        const payload = {
            token: token,
            latitude: stopLat,
            longitude: stopLng,
            address: stopAddress,
            city_id: cityFilter,
            radius: stopRadius,
            // address: stopAddress,
            name: stopName,
            stop_image: imageUrls
        };
        if(stopId!=''){
            payload.stop_id = stopId;
        }
        if(isDelete===1){
            payload.is_active = 0;
        }

        try {
            const url = operationsUrl + '/shuttle/add_update_shuttle_stops';
            const response = await makePostRequestToUrl(url,payload);
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true);
                setOpenAddModal(false);
                setOpenEditModal(false);
                fetchShuttleStops();
            }
            else if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
            else {
                setMessage(response.message)
                showSnackbar(true);
            }

            setIsDelete(0);

        } catch (error) {
            setMessage(error);
        }
    }
    const handleCityChange = (e) =>{
        const city =  cities.find((cityObj) => cityObj.city_id === e)
        setCityFilter(e);
    }

    useEffect(() => {
        if (map && stopLat && stopLng) {
            // Create a new bounds object
            const bounds = new window.google.maps.LatLngBounds();
            
            // Add the stop location to bounds
            const stopLocation = new window.google.maps.LatLng(Number(stopLat), Number(stopLng));
            bounds.extend(stopLocation);
            
            // Pan to the stop location
            map.panTo(stopLocation);
            
            // Set appropriate zoom level for a stop location
            map.setZoom(16);

            // Update map center
            setMapCenter({ 
                lat: Number(stopLat), 
                lng: Number(stopLng) 
            });
        }
    }, [map, stopLat, stopLng, stopAddress]);

    const loadAutocomplete = () => {
        if (inputRef.current) {
            if (window.google && window.google.maps && window.google.maps.places) {
                const autocompleteOptions = {
                    types: ['geocode', 'establishment'],
                };
                
                // Only add country restriction if map_search_preference has a value
                if (map_search_preference && map_search_preference != '') {
                    autocompleteOptions.componentRestrictions = { country: map_search_preference };
                }
                
                const autocomplete = new window.google.maps.places.Autocomplete(
                    inputRef.current, 
                    autocompleteOptions
                );

                // Add an event listener for when the place is selected
                autocomplete.addListener('place_changed', () => {
                    const place = autocomplete.getPlace();

                    if (place.geometry) {
                        setStopLat(place.geometry.location.lat());
                        setStopLng(place.geometry.location.lng());
                        if (place.address_components && Array.isArray(place.address_components)) {
                            const filteredComponents = place.address_components
                                .map(comp => comp.long_name)
                                .filter(name => {
                                    // Remove plus codes like WRGM+RPV and similar
                                    return !/^[A-Z0-9]{4,}\+[A-Z0-9]{2,}$/.test(name);
                                });
                
                            const address = filteredComponents.join(', ');
                            setStopAddress(address);
                        } else {
                            setStopAddress(''); // Don't use formatted_address fallback
                        }
                    // setPickupLatLng({
                    // lat: place.geometry.location.lat(),
                    // lng: place.geometry.location.lng(),
                    // });
                    }
                });
            }
        }
    };

    useEffect(() => {
        loadAutocomplete();
    }, [openAddModal, openEditModal]);

    useEffect(() => {
        if (!map) {
            console.warn('Map is not loaded yet');
            return;
        }
    
        if (shuttleStopsData.length > 0) {
            try {
                const bounds = new window.google.maps.LatLngBounds();
    
                shuttleStopsData.forEach((marker) => {
                    if (marker.latitude && marker.longitude) {
                        bounds.extend(new window.google.maps.LatLng(marker.latitude, marker.longitude));
                    } else {
                        console.warn('Invalid marker data:', marker);
                    }
                });
    
                map.fitBounds(bounds);
            } catch (error) {
                console.error('Error fitting map bounds:', error);
            }
        } else {
            // When no shuttle stops, fit bounds to city's geofence
            const selectedCity = cities.find(c => c.city_id === cityFilter);
            if (selectedCity?.geofence[0]?.length) {
                try {
                    const bounds = new window.google.maps.LatLngBounds();
                    selectedCity.geofence[0].forEach(coord => {
                        bounds.extend(new window.google.maps.LatLng(coord.x, coord.y));
                    });
                    map.fitBounds(bounds);
                } catch (error) {
                    console.error('Error fitting geofence bounds:', error);
                }
            }
        }
    }, [map, shuttleStopsData, cityFilter]);
    
    // useEffect(() => {
    //     if (stopLat && stopLng) {
    //         setCenterr({ lat: Number(stopLat), lng: Number(stopLng) });
    //     }
    // }, [stopLat, stopLng]);

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return; 
        }
        showSnackbar(false); 
    };

    useEffect(() => {
        if (map && openEditModal && stopLat && stopLng) {
            console.log("Panning to:", stopLat, stopLng);
            map.panTo({ lat: stopLat, lng: stopLng });  // Move map to marker position
        }
    }, [map, openEditModal, stopLat, stopLng]);    
    
    const handleRemoveImage = async(index) => {
        setImageList((prevList) => prevList.filter((_, imgIndex) => imgIndex !== index));
        const imageToDelete = imageList[index];
        // const url = operationsUrl + '/delete_image';
        if (!imageToDelete) {
            console.error('No image to delete');
            return;
        }
    }

    const handleAddImages = async () => {
        if (selectedFiles.length === 0) {
            alert("Please select images to upload.");
            return;
        }

        const uploadedUrls = []; // To store uploaded image URLs
        for (const selectedFile of selectedFiles) {
            const formData = new FormData();
            formData.append("image", selectedFile.file);
            const url = operationsUrl + '/upload_image'
            try {
                const response = await axios.post(
                url,
                formData,
                {
                    headers: { "Content-Type": "multipart/form-data" },
                }
                );

                const s3Url = response.data.url;
                uploadedUrls.push(s3Url); // Add the uploaded image URL to the list
            } catch (error) {
                console.error("Error uploading image:", error);
                alert("Error uploading one or more images.");
            }
        }

        // Add uploaded URLs to the final image list
        setImageList((prevList) => [...prevList, ...uploadedUrls]);

        setSelectedFiles([]); // Clear the preview list
    };

    const handleFileChange = (event) => {
        const files = Array.from(event.target.files); // Get all selected files
        const newFiles = files.map((file) => ({
        file,
        previewURL: URL.createObjectURL(file), // Generate a preview URL for each file
        }));
        setSelectedFiles((prevFiles) => [...prevFiles, ...newFiles]); // Append new files to the list
    };

    useEffect(()=>{
        if(selectedFiles.length>0)
        handleAddImages();
    }, [selectedFiles]);

    return(
        <div>
            {tokenExpired && (<TokenError/>)}

            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>Stops Management</Typography>

            <Grid2 item container spacing={2} sx={{marginTop:'2%'}}>
                <Grid2 item>
                    <Select value={cityFilter} 
                    onChange={(e) => handleCityChange(e.target.value)} displayEmpty
                    style={{width: '190px',height:'50px',borderRadius:'8px',backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF'}}>
                        <MenuItem value="">Select City</MenuItem>
                        {cities.map((city) => (
                            <MenuItem key={city.city_name} value={city.city_id}>
                                {city.city_name}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid2>

                <Grid2 item>
                    <Button
                        variant="contained"
                        onClick={handleOpenAddModal}
                        style={{width:'190px', height:'50px', backgroundColor:'#000000', textTransform:'none', borderRadius:'8px'}}>
                        + Add Stop
                    </Button>
                </Grid2>
            </Grid2>
            
            {shuttleStopsData.length>1 && (
                <Grid2 sx={{marginTop:'1%'}}><Typography>{shuttleStopsData.length} Results Found</Typography></Grid2>
            )}
            {shuttleStopsData.length==0 && (
                <Grid2 sx={{marginTop:'1%'}}><Typography>No Stops Found</Typography></Grid2>
            )}
            

            <Grid2 item container size={12} spacing={2} sx={{marginTop:'1%'}}>
                <Grid2 item size={4} sx={{ overflowY:'auto', maxHeight:'610px'}}>
                    {(shuttleStopsData).map((data) => {
                        const type = constants.CustomZoneTypeConst[data.type] || null;
                        return(
                            <Grid2 item sx={{backgroundColor:'#fff', borderRadius:'12px', padding:'4px', marginBottom:'4%', cursor:'pointer'}}
                                key={data.zone_id} onClick={() => handleGridClick(data)}
                                >
                                <Grid2 item container spacing={1.6} sx={{padding:'12px'}}>
                                    {/* <Typography>{data.name}</Typography> */}
                                    <Typography sx={{color:'#1A1E25', fontSize:'18px'}}>{data.name}</Typography>
                                    <Typography sx={{marginLeft:'auto', color:'#000', fontSize:'14px', backgroundColor:'#F9F9F9', padding:'4px 8px', borderRadius:'4px', color:'#83888E'}}>ID: {data.stop_id}</Typography>
                                </Grid2>

                                <Grid2 sx={{backgroundColor:'#F9F9F9', padding:'8px', margin:'6px', borderRadius:'8px'}}>
                                    <Grid2 container size={12}>
                                        {data.stop_image!="" && (
                                            <Grid2 item size={2} sx={{marginRight:'4%', alignContent:'center'}}>
                                                <img style={{borderRadius:'8px'}} height="58px" width="58px" src={data.stop_image.split(';;')[0]} alt="stopsdefault" />
                                            </Grid2>
                                        )}
                                        {data.stop_image=="" && (
                                            <Grid2 item size={2} sx={{marginRight:'4%', alignContent:'center'}}>
                                                <img style={{borderRadius:'8px'}} height="58px" width="58px" src={stopsDefaultImg} alt="stopsdefault" />
                                            </Grid2>
                                        )}

                                        <Grid2 item size={9.5}>
                                            <Typography sx={{fontSize:'12px', color:'#83888E', marginLeft:'2%', letterSpacing:'1px'}}>Stop Location</Typography>

                                            <Grid2 item sx={{display:'flex', marginTop:'4px'}}>
                                                <img height="20px" width="26px" src={mapPin} alt="mapPin"/>
                                                <Typography sx={{fontSize:'15px', color:'#2A313C'}}>{data.address}</Typography>
                                            </Grid2>
                                        </Grid2>
                                    </Grid2>
                                    
                                    <hr style={{ marginTop: '10px', marginBottom: '16px', border: 'none', borderTop: '1px solid #ccc' }} />

                                    <Grid2 item sx={{display:'flex'}}>
                                        <Grid2 item sx={{display:'flex'}}>
                                            <img src={RadiusFrame} alt="RadiusFrame" />
                                            <Typography sx={{marginLeft:'8%'}}>Radius</Typography>
                                        </Grid2>
                                        <Typography sx={{marginLeft:'auto'}}>{data.radius}m</Typography>
                                    </Grid2>
                                </Grid2>

                                {/* <hr/> */}
                                

                                <Grid2 item container sx={{marginBottom:'8px', alignItems: 'center', gap: 1 }}>
                                    <Button onClick={() => handleDeleteFunc(data)}>
                                        <img src={binButton} alt="bin" />
                                    </Button>

                                    <Button variant="contained" sx={{ backgroundColor:'#0DBA78', height:"42px", flexGrow: 1, marginRight:'6px'}} 
                                    onClick={() => handleOpenEdit(data)}
                                    >
                                        <Typography sx={{color:'#EFFBF7', textTransform:'none'}}>Edit</Typography>
                                    </Button>
                                </Grid2>
                            </Grid2>
                        )
                    })}
                    
                </Grid2>

                <Grid2 item size={8}>
                    <Grid2 className='mainBox'>
                        {isLoaded ? (
                            <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={6} onLoad={onLoad} onUnmount={onUnmount}>
                                
                                {selectedGridData && [selectedGridData].map((stop, index) => (
                                    <Marker
                                        key={stop.stop_id}
                                        position={{
                                            lat: Number(stop.latitude),
                                            lng: Number(stop.longitude)
                                        }}
                                        title={stop.name}
                                        icon={{
                                            url: selectedStopMarker,
                                            scaledSize: new window.google.maps.Size(30, 30)
                                        }}
                                    />
                                ))}
                                {shuttleStopsData && shuttleStopsData.length > 0 && shuttleStopsData.map((marker) => {
                                    return (
                                        <Marker
                                            key={marker.stop_id}
                                            position={{ lat: Number(marker.latitude), lng: Number(marker.longitude) }}
                                            title={marker.name} 
                                            icon={{
                                                url: stopMarker,
                                                scaledSize: new window.google.maps.Size(30, 30)
                                            }}
                                        />
                                    );
                                })}

                            </GoogleMap>
                            
                        ): (<></>)}
                    </Grid2>
                </Grid2>
            </Grid2>

            {(openAddModal || openEditModal) && (
                <div 
                style={{position: 'fixed',top: 65, right:0, height: '100%',width: '78%',backgroundColor: '#f9f9f9',
                    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',transition: 'right 0.3s ease-in-out',
                    zIndex: 1000,overflowY: 'auto',padding: 20
                }}>
                    <Box>
                        <div style={{ position: 'relative', padding: '40px 0' }}>
                            <IconButton aria-label="close" onClick={handleClose}
                                style={{
                                    position: 'absolute',top: '-15px',left: '1px',color: '#333',zIndex: 10}}>
                                <CloseIcon style={{ fontSize: '32px', fontWeight: 'bold' }} />
                            </IconButton>

                            <Grid2 item container spacing={2} size={12} sx={{marginLeft:'12px'}}>
                                <Grid2 item size={5} sx={{backgroundColor:'#fff', padding:'12px', borderRadius:'12px', overflowY:'auto',height: 'auto'}}>
                                    <Typography sx={{color:'#4E545D', fontSize:'24px', fontWeight:500}}>Add New Stop</Typography>
                                    
                                    <Grid2 item sx={{marginTop:'4%', padding:'4px'}}>
                                        <Label>Enter Stop Name<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField  sx={{marginTop:'2%'}}
                                            placeholder="Stop Name" fullWidth variant="outlined" type="text" 
                                            value={stopName}
                                            onChange={(e) => setStopName(e.target.value)}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {height: '46px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                            }}
                                        />
                                    </Grid2>

                                    <Grid2 item sx={{marginTop:'4%', padding:'4px'}}>
                                        <Label>Stop Address<span style={{ color: 'red' }}>*</span></Label>
                                        <input ref={inputRef} type="text" placeholder=" Search Location" className="filterBtn"
                                            style={{
                                                width:'94%', marginTop:'2%',
                                                backgroundPosition: '8px center',
                                            }}
                                            value={stopAddress}
                                            onChange={(e) => setStopAddress(e.target.value)}
                                        />
                                    </Grid2>

                                    <Grid2 item sx={{marginTop:'4%', padding:'4px'}}>
                                        <Label>Radius (in meters) <span style={{ color: 'red' }}>*</span></Label>
                                        <TextField  sx={{marginTop:'2%'}}
                                            placeholder="Hub Radius" fullWidth variant="outlined" type="text" 
                                            value={stopRadius}
                                            onChange={(e) => setStopRadius(e.target.value)}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {height: '46px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                            }}
                                        />
                                    </Grid2>

                                    {/* <Grid2 item sx={{marginTop:'4%', padding:'4px'}}>
                                        <Label>Image</Label>
                                        <br/>
                                        {image && (
                                            <Grid2 sx={{marginTop:'2%'}}>
                                                <img src={image} height="50px" width="50px" alt="Image"/>
                                            </Grid2>
                                        )}
                                        
                                        <input
                                            type="file"
                                            accept="image/*"
                                            // multiple 
                                            // value={image}
                                            onChange={handleFileChange}
                                            style={{ marginBottom: "10px", marginTop:'2%' }}
                                        />
                                    </Grid2> */}
                                    <Grid2 item sx={{marginTop:'4%', padding:'4px'}}>
                                        <Label>Image</Label>
                                        {/* File Input */}
                                        {imageList.length >= 0 && imageList.length < 5 && (
                                            <Grid2 item xs={12} sx={{ marginTop:'2%'}}>
                                                <input
                                                    type="file"
                                                    accept="image/*"
                                                    multiple
                                                    onChange={handleFileChange}
                                                    style={{ marginBottom: "10px" }}
                                                />
                                            </Grid2>
                                        )}

                                        {/* Add Images Button */}
                                        {/* {imageList.length >= 0 && imageList.length < 5 && selectedFiles.length!=0 &&(
                                            <Grid2 item xs={12} sx={{marginTop:'2%'}}>
                                                <Button sx={{textTransform:'none', backgroundColor:'#4f95c4'}}
                                                    variant="contained" size="small"
                                                    onClick={handleAddImages}
                                                    disabled={selectedFiles.length === 0}
                                                >
                                                    Upload Image
                                                </Button>
                                            </Grid2>

                                        )} */}

                                        {/* Uploaded Images Display */}
                                        {imageList.length > 0 && (
                                            <Grid2 item xs={12} sx={{marginTop:'2%'}}>
                                                <Grid2 container spacing={2}>
                                                    {imageList.map((url, index) => (
                                                        <Grid2 item key={index}>
                                                        <img
                                                            src={url}
                                                            alt={`Uploaded ${index}`}
                                                            style={{
                                                            width: "50px",
                                                            height: "50px",
                                                            objectFit: "cover",
                                                            borderRadius: "8px",
                                                            }}
                                                        />
                                                        <button
                                                            onClick={() => handleRemoveImage(index)}
                                                            style={{color: "white", padding: "3px 6px",
                                                                backgroundColor: "rgba(0,0,0,0.54)",
                                                                borderRadius: "50%", border: "none", cursor: "pointer",
                                                            }}>
                                                            x
                                                        </button>
                                                        </Grid2>
                                                    ))}
                                                </Grid2>
                                            </Grid2>
                                        )}
                                    </Grid2>

                                    <Grid2 container item sx={{marginTop:'6%', justifyContent:'center', marginBottom:'4%'}} spacing={4}>
                                        <Grid2 item>
                                            <Button variant="contained" sx={{backgroundColor:'#0065FF'}} onClick={saveData}>{openAddModal ? 'Create' : 'Update'}</Button>
                                        </Grid2>
                                        <Grid2 item>
                                            <Button variant="contained" sx={{backgroundColor:'#D14545'}} onClick={handleClose}>Cancel</Button>
                                        </Grid2>
                                    </Grid2>
                                </Grid2>

                                <Grid2 item size={7}>

                                    {/* <CommonGeofence geofence={customGeofence ? customGeofence : null} onUpdatePolygon={handleUpdatePolygon} /> */}
                                    {isLoaded ? (
                                        <GoogleMap key={`edit-map-${stopId}-${mapCenter.lat}-${mapCenter.lng}`} mapContainerStyle={containerStyle} center={mapCenter} zoom={6} onLoad={onLoad} onUnmount={onUnmount}>
                                            {/* {console.log("Rendering Marker at:", stopLat, stopLng)} */}
                                            {stopLat && stopLng && stopAddress &&
                                                (
                                                <Marker
                                                    key={`marker-${stopId}-${stopLat}-${stopLng}-${Date.now()}`}  // Ensures re-render
                                                    position={{ lat: Number(stopLat), lng: Number(stopLng) }}
                                                    title={stopName} 
                                                    icon={{
                                                        url: selectedStopMarker,
                                                        scaledSize: new window.google.maps.Size(40, 40)
                                                    }}
                                                />
                                                )
                                            }

                                        </GoogleMap>
                                        
                                    ): (<></>)}
                                </Grid2>
                            </Grid2>
                        </div>
                    </Box>
                </div>
            )}

            <Snackbar open={snackbar} autoHideDuration={2000} onClose={handleSnackbarClose} message={message}></Snackbar>

        </div>
    )
}

export default ShuttleStops;